"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum;
(function (TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum) {
    TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum["StatusUnspecified"] = "INDEXING_STATUS_UNSPECIFIED";
    TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum["InProgress"] = "INDEXING_IN_PROGRESS";
    TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum["Pending"] = "INDEXING_PENDING";
    TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum["FailedRetryPending"] = "INDEXING_FAILED_RETRY_PENDING";
    TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum["Failed"] = "INDEXING_FAILED";
    TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum["Complete"] = "INDEXING_COMPLETE";
    TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum["Unsupported"] = "INDEXING_UNSUPPORTED";
})(TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum = exports.TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum || (exports.TableauSemanticsGetIndexingStatusResponseIndexingStatusEnum = {})); /**
* @export
* @enum {string}
*/
var TableauSemanticsGetIndexingStatusResponseErrorCodeEnum;
(function (TableauSemanticsGetIndexingStatusResponseErrorCodeEnum) {
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["ErrorUnspecified"] = "INDEXING_ERROR_UNSPECIFIED";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["NoError"] = "INDEXING_NO_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["InternalError"] = "INDEXING_INTERNAL_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["ConnectionError"] = "INDEXING_CONNECTION_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["InvalidFieldError"] = "INDEXING_INVALID_FIELD_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["FieldNotFoundError"] = "INDEXING_FIELD_NOT_FOUND_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["CredentialsMissingError"] = "INDEXING_CREDENTIALS_MISSING_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["CredentialsInvalidError"] = "INDEXING_CREDENTIALS_INVALID_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["UserReferenceError"] = "INDEXING_USER_REFERENCE_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["SlowPerformanceError"] = "INDEXING_SLOW_PERFORMANCE_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["PermissionDeniedError"] = "INDEXING_PERMISSION_DENIED_ERROR";
    TableauSemanticsGetIndexingStatusResponseErrorCodeEnum["ValueLengthExceededError"] = "INDEXING_VALUE_LENGTH_EXCEEDED_ERROR";
})(TableauSemanticsGetIndexingStatusResponseErrorCodeEnum = exports.TableauSemanticsGetIndexingStatusResponseErrorCodeEnum || (exports.TableauSemanticsGetIndexingStatusResponseErrorCodeEnum = {}));
function TableauSemanticsGetIndexingStatusResponseFromJSON(json) {
    return TableauSemanticsGetIndexingStatusResponseFromJSONTyped(json, false);
}
exports.TableauSemanticsGetIndexingStatusResponseFromJSON = TableauSemanticsGetIndexingStatusResponseFromJSON;
function TableauSemanticsGetIndexingStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'indexingStatus': !runtime_1.exists(json, 'indexing_status') ? undefined : json['indexing_status'],
        'errorCode': !runtime_1.exists(json, 'error_code') ? undefined : json['error_code'],
        'indexedValueConceptsVersion': !runtime_1.exists(json, 'indexed_value_concepts_version') ? undefined : json['indexed_value_concepts_version'],
    };
}
exports.TableauSemanticsGetIndexingStatusResponseFromJSONTyped = TableauSemanticsGetIndexingStatusResponseFromJSONTyped;
function TableauSemanticsGetIndexingStatusResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'indexing_status': value.indexingStatus,
        'error_code': value.errorCode,
        'indexed_value_concepts_version': value.indexedValueConceptsVersion,
    };
}
exports.TableauSemanticsGetIndexingStatusResponseToJSON = TableauSemanticsGetIndexingStatusResponseToJSON;
